import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'recursiveSection',
  props: {
    fullHeaders: null,
    item: null,
    allItems: null,
    currentHeader: null
  },
  emits: ["row-action"],
  setup: function setup(__props) {
    var props = __props;
    var getChildItems = function getChildItems(parentId, items) {
      return items.filter(function (i) {
        return i.parentId === parentId;
      });
    };
    var childItems = computed(function () {
      return getChildItems(props.item.id, props.allItems || []);
    });
    function getLabelEn(child) {
      return child && child.labelI18n && child.labelI18n.en ? child.labelI18n.en : '';
    }
    function getLabelDe(child) {
      return child && child.labelI18n && child.labelI18n.de ? child.labelI18n.de : '';
    }
    function getTaxonomyLabel(child) {
      return child && child.taxonomy && child.taxonomy.label ? child.taxonomy.label : '';
    }
    return {
      __sfc: true,
      props: props,
      getChildItems: getChildItems,
      childItems: childItems,
      getLabelEn: getLabelEn,
      getLabelDe: getLabelDe,
      getTaxonomyLabel: getTaxonomyLabel
    };
  }
});